<template>
  <div class="main-content-container overflow-hidden">
    <DetailCatalog />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import DetailCatalog from "@/components/Pages/Management/Catalog/DetailCatalog.vue";

export default defineComponent({
  name: "DetailCatalogPage",
  components: {
    DetailCatalog,
  },
});
</script>
